import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    Input,
    MenuItem,
    Select,
    TableCell,
    TableRow,
    TextField
} from "@mui/material";
import * as React from "react";
import { IapSelector } from "../iap";
import { IPackItem } from "../Items/item";
import { PackItems } from "../Items/items";

interface ValueBundleEntryProps {
    entry: any;
    classes: any;

    onRemove(item: ValueBundleItem);

    onUpdate(item: ValueBundleItem);
}

interface ValueBundleEntryState {
    entry: ValueBundleItem;

    modalVisible: boolean;
}

export interface ValueBundleItem {
    id: string;
    packageId: string;
    title: string;
    subtitle: string;
    googleId: string;
    appleId: string;
    samsungId: string;
    huaweiId: string;
    category: string;
    quantity: number;
    availableEndOf: string;
    bonusValue: number;
    validatePayment: boolean;
    items: IPackItem[];
}

export class ValueBundleEntry extends React.Component<ValueBundleEntryProps, ValueBundleEntryState> {

    constructor(props: ValueBundleEntryProps) {
        super(props);

        this.state = {
            entry: {
                id: this.props.entry.id,
                packageId: this.props.entry.packageId,
                title: this.props.entry.title,
                subtitle: this.props.entry.subtitle,
                googleId: this.props.entry.googleId,
                appleId: this.props.entry.appleId,
                samsungId: this.props.entry.samsungId,
                huaweiId: this.props.entry.huaweiId,
                category: this.props.entry.category,
                quantity: this.props.entry.quantity,
                availableEndOf: this.props.entry.availableEndOf,
                bonusValue: parseFloat((this.props.entry.bonusValue * 100).toFixed(2)),
                validatePayment: this.props.entry.validatePayment,
                items: this.props.entry.items,
            },

            modalVisible: false
        };
    }

    onValueChange = (key: keyof ValueBundleItem, type: "string" | "numeric" | "bool", value: any) => {
        this.setState(state => {
            switch (type) {
                case "string":
                    value = String(value);
                    break;
                case "numeric":
                    value = +value;
                    break;
                case "bool":
                    value = value === "true";
                    break;
                default:
            }

            state.entry[key] = value as never;

            return state;
        }, () => {
            this.props.onUpdate({
                ...this.state.entry,
                bonusValue: this.state.entry.bonusValue / 100
            });
        });
    };

    onIapChange = (key: keyof ValueBundleItem, item) => {
        this.onValueChange(key, "string", item.productId);
    };

    remove = () => {
        if (!confirm("Are you sure you want to delete this Value Bundle?")) {
            return;
        }

        this.props.onRemove(this.state.entry);
    };

    edit = () => {
        this.setState({
            modalVisible: true
        });
    };

    updateItems = (items: IPackItem[]) => {
        const entry = {...this.state.entry};

        entry.items = items;

        this.setState({
            entry
        }, () => {
            this.props.onUpdate({
                ...this.state.entry,
                bonusValue: this.state.entry.bonusValue / 100
            });
        });
    };

    render() {
        return <TableRow
            key={this.state.entry.id}
            hover={true}
            className={this.props.classes.tableRow}
        >
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.packageId}
                       onChange={(e) => this.onValueChange("packageId", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.title}
                       onChange={(e) => this.onValueChange("title", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" value={this.state.entry.subtitle}
                       onChange={(e) => this.onValueChange("subtitle", "string", e.target.value)}
                       style={{width: "100%"}}/>
            </TableCell>
            <TableCell>
                <Select value={this.state.entry.category} size="small"
                        onChange={(e) => this.onValueChange("category", "string", e.target.value)}>
                    <MenuItem value={"combat"}>Combat</MenuItem>
                    <MenuItem value={"gunsmith"}>Gunsmith</MenuItem>
                    <MenuItem value={"research"}>Research</MenuItem>
                    <MenuItem value={"building"}>Building</MenuItem>
                    <MenuItem value={"daily"}>Daily</MenuItem>
                </Select>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.entry.quantity}
                       onChange={(e) => this.onValueChange("quantity", "numeric", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Select value={this.state.entry.availableEndOf} size="small"
                        onChange={(e) => this.onValueChange("availableEndOf", "string", e.target.value)}>
                    <MenuItem value={"hour"}>Hour</MenuItem>
                    <MenuItem value={"day"}>Day</MenuItem>
                    <MenuItem value={"week"}>Week</MenuItem>
                    <MenuItem value={"month"}>Month</MenuItem>
                </Select>
            </TableCell>
            <TableCell>
                <TextField size="small" variant="outlined" type="number" value={this.state.entry.bonusValue}
                       onChange={(e) => this.onValueChange("bonusValue", "numeric", e.target.value)}/>
            </TableCell>
            <TableCell>
                <Select value={this.state.entry.validatePayment} size="small"
                        onChange={(e) => this.onValueChange("validatePayment", "bool", e.target.value)}>
                    <MenuItem value={"true"}>Yes</MenuItem>
                    <MenuItem value={"false"}>No</MenuItem>
                </Select>
            </TableCell>
            <TableCell>
                <Grid container spacing={2}>
                    <Grid item>
                        <Button disableElevation onClick={this.edit} size="small">
                            <EditIcon color={"primary"}/>
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button disableElevation onClick={this.remove} size="small">
                            <DeleteForeverIcon color={"error"}/>
                        </Button>
                    </Grid>
                </Grid>
            </TableCell>

            <Dialog
                open={this.state.modalVisible}
                onClose={() => this.setState({modalVisible: false})}
                fullWidth={true}
                maxWidth={"md"}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle id="draggable-dialog-title">
                    Edit {this.state.entry.packageId}
                </DialogTitle>
                <DialogContent dividers>
                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.googleId} platform={"ios/android"} label={"Google ID"}
                                     onChange={(_e, item) => this.onIapChange("googleId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.appleId} platform={"ios/android"} label={"Apple ID"}
                                     onChange={(_e, item) => this.onIapChange("appleId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.samsungId} platform={"udp"} label={"Samsung ID"}
                                     onChange={(_e, item) => this.onIapChange("samsungId", item)}/>
                    </FormControl>

                    <FormControl required fullWidth style={{marginBottom: 20}}>
                        <IapSelector value={this.state.entry.huaweiId} platform={"udp"} label={"Huawei ID"}
                                     onChange={(_e, item) => this.onIapChange("huaweiId", item)}/>
                    </FormControl>

                    <PackItems list={this.state.entry.items} onUpdate={this.updateItems}/>
                </DialogContent>

                <DialogActions>
                    <Button disableElevation onClick={() => this.setState({modalVisible: false})} color="primary" variant="contained" size="small">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </TableRow>;
    }
}
